import { styled } from "@volkswagen-onehub/components-core";
import React from "react";

const Wrapper = styled.div`
  width: 100%;
  max-width: 2560px;
  @media (min-width: 1025px) {
    width: auto;
    padding: 0 ${props => props.theme.size.grid001};
  }
`;

const SkeletonText = styled.div`
  height: 20px;
  width: 200px;
  background: linear-gradient(
    90deg,
    ${({theme}) => theme.colors.background.tertiary} 25%,
    ${({theme}) => theme.colors.background.secondary} 50%,
    ${({theme}) => theme.colors.background.tertiary} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: ${({theme}) => theme.size.borderRadius.xSmall};
  margin: 0 var(--size-grid002) 8px;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  @media (min-width: 1025px) {
    margin: 0 0 8px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  overflow-x: scroll;
  scrollbar-width: none;
  column-gap: ${({theme}) => theme.size.static200};
  padding: 2px;
  mask-image: linear-gradient(to right, transparent, black 8.33334% 91.66667%, transparent);

  > :first-child {
    margin-inline-start: var(--size-grid002);
  }
  > :last-child {
    margin-inline-end: var(--size-grid002);
  }

  @media (min-width: 1025px) {
    mask-image: initial;
    row-gap: 16px;
    > :first-child {
      margin-inline-start: 0;
    }
  }
`;

const SkeletonThumb = styled.div`
  flex: 0 0 auto;
  width: calc((100vw - var(--size-grid004) - var(--size-dynamic0040))/2);
  height: 120px;
  background: linear-gradient(
    90deg,
    ${({theme}) => theme.colors.background.tertiary} 25%,
    ${({theme}) => theme.colors.background.secondary} 50%,
    ${({theme}) => theme.colors.background.tertiary} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: ${({theme}) => theme.size.borderRadius.filterTag};
  border: ${({theme}) => theme.size.border.default} solid ${({theme}) => theme.colors.border.divider};

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  @media (min-width: 560px) {
    width: calc((100vw - var(--size-grid004) - (var(--size-dynamic0040)*2))/3);
  }

  @media (min-width: 1025px) {
    width: 200px;
  }
`;

export const VehicleSelectionSkeleton = () => {
  return (
    <Wrapper>
      <SkeletonText />
      <Container>
        {[...Array(3)].map((_, i) => (
          <SkeletonThumb key={i} />
        ))}
      </Container>
    </Wrapper>
  );
};
